<template>
    <Widget :title="$t('components.WebsitesStats.TotalUsersByCountry')" :loading="loading">
        <!-- <div class="d-flex mb-4 align-center" v-if="!hideControls">
            <small>List view</small>
            <v-switch class="locations-view-selector" dense v-model="mapView" />
            <small>Map view</small>
        </div> -->
        <ListChart :items="topLocations"/>
    </Widget>
</template>

<script>
/** 
 * Total Users By Country contains the functions to parse and format data from 
 * the API to render a map with Total users locations.
 */

import Widget from '@/components/dashboard/Widget';

import ListChart from'@/components/dashboard/charts/ListChart';

export default {
    name: 'TotalUsersByCountry',
    data: () => ({ 
        dataSource: {},
        mapView: true
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        locations: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.mapView = this.defaultMapView;
    },
    computed: {
        topLocations() {
          if(!this.locations.locations) return [];
          return Object.entries(this.locations.locations).map(([key, value]) => ({ label: key, value })).slice(0, 12);
        }

    },
    components: { Widget, ListChart }
}
</script>

<style >
.locations-view-selector { margin: 0 20px 0; }
.locations-view-selector  .v-messages { display: none!important; }
</style>